export class Cep {
    id: number;
    cep: number;
    uf: string;
    cidade: string;
    logradouro: string;
    bairro: string;
    nome: string;
    tipocep: number;
}
